import axios from './HTTP'

export default {
  markComplete (taskId, callback, errorCallback) {
    axios
      .patch(`/api/tasks/${ taskId }/mark_complete.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  markIncomplete (taskId, callback, errorCallback) {
    axios
      .patch(`/api/tasks/${ taskId }/mark_incomplete.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  }
}
